const initializeFestivalOrganizerSearch = () => {
    const container = document.getElementById(
        'festival-organizer-search'
    );

    const queryInput = document.getElementById(
        'organizer-member-query'
    );

    const resultsContainer = document.getElementById(
        'organizer-member-results'
    );

    const assignmentForm = document.getElementById(
        'organizer-assignment-form'
    );

    const userIdInput = document.getElementById(
        'organizer-user-id'
    );

    const selectedName = document.getElementById(
        'organizer-selected-name'
    );

    const selectedDetails = document.getElementById(
        'organizer-selected-details'
    );

    if (
        ! container
        || ! queryInput
        || ! resultsContainer
        || ! assignmentForm
        || ! userIdInput
    ) {
        return;
    }

    const searchUrl = container.dataset.searchUrl;

    if (! searchUrl) {
        return;
    }

    let debounceTimer = null;
    let requestController = null;

    const hideResults = () => {
        resultsContainer.classList.add('hidden');
        resultsContainer.innerHTML = '';
    };

    const showMessage = (message) => {
        resultsContainer.innerHTML = `
            <p class="px-4 py-4 text-sm text-zinc-500">
                ${message}
            </p>
        `;

        resultsContainer.classList.remove('hidden');
    };

    const selectUser = (user) => {
        userIdInput.value = String(user.id);

        selectedName.textContent = user.name;

        selectedDetails.textContent = [
            user.username ? `@${user.username}` : null,
            user.email,
        ]
            .filter(Boolean)
            .join(' · ');

        assignmentForm.classList.remove('hidden');

        queryInput.value = user.label;

        hideResults();
    };

    const renderUsers = (users) => {
        resultsContainer.innerHTML = '';

        if (! Array.isArray(users) || users.length === 0) {
            showMessage('No eligible members were found.');
            return;
        }

        users.forEach((user) => {
            const button = document.createElement('button');

            button.type = 'button';

            button.className =
                'flex w-full items-center gap-3 border-b border-zinc-100 px-4 py-3 text-left last:border-b-0 hover:bg-zinc-50 dark:border-zinc-800 dark:hover:bg-zinc-800';

            const initials = user.name
                .split(/\s+/)
                .filter(Boolean)
                .slice(0, 2)
                .map((part) => part.charAt(0).toUpperCase())
                .join('');

            const avatar = user.profile_photo_url
                ? `
                    <img
                        src="${user.profile_photo_url}"
                        alt=""
                        class="h-10 w-10 rounded-full object-cover"
                    >
                `
                : `
                    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-fuchsia-600 font-black text-white">
                        ${initials}
                    </span>
                `;

            const username = user.username
                ? `<span class="text-zinc-500">@${user.username}</span>`
                : '';

            button.innerHTML = `
                ${avatar}

                <span class="min-w-0">
                    <span class="block font-bold text-zinc-900 dark:text-white">
                        ${user.name}
                    </span>

                    <span class="block truncate text-sm text-zinc-500">
                        ${username}
                        ${username ? ' · ' : ''}
                        ${user.email}
                    </span>
                </span>
            `;

            button.addEventListener(
                'click',
                () => selectUser(user)
            );

            resultsContainer.append(button);
        });

        resultsContainer.classList.remove('hidden');
    };

    const searchMembers = async (query) => {
        requestController?.abort();
        requestController = new AbortController();

        const url = new URL(
            searchUrl,
            window.location.origin
        );

        url.searchParams.set('query', query);

        showMessage('Searching members…');

        try {
            const response = await fetch(
                url.toString(),
                {
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    credentials: 'same-origin',
                    signal: requestController.signal,
                }
            );

            if (! response.ok) {
                throw new Error(
                    `Search failed with status ${response.status}.`
                );
            }

            const data = await response.json();

            renderUsers(data.users);
        } catch (error) {
            if (error.name === 'AbortError') {
                return;
            }

            console.error(
                'Unable to search organizer candidates:',
                error
            );

            showMessage(
                'The member search could not be completed.'
            );
        }
    };

    queryInput.addEventListener(
        'input',
        () => {
            window.clearTimeout(debounceTimer);

            userIdInput.value = '';
            assignmentForm.classList.add('hidden');

            const query = queryInput.value.trim();

            if (query.length < 2) {
                hideResults();
                return;
            }

            debounceTimer = window.setTimeout(
                () => searchMembers(query),
                300
            );
        }
    );

    document.addEventListener(
        'click',
        (event) => {
            if (! container.contains(event.target)) {
                hideResults();
            }
        }
    );
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializeFestivalOrganizerSearch
    );
} else {
    initializeFestivalOrganizerSearch();
}